import { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import api from "../../services/api";
import * as S from "./styled";

import { useAuth } from "../../context/auth";

const ListaRedacoes = ({ turma, id_turma }) => {
  const { user } = useAuth();
  const date1 = new Date();
  const [loading, setLoading] = useState(true);
  const [redacoes, setRedacoes] = useState([]);
  const [redacoesIA, setRedacoesIA] = useState([]);
  const [redacoesUERJ, setRedacoesUERJ] = useState([]);
  const [tipoTurma, setTipoTurma] = useState(null);
  const history = useHistory();

  const trazerTotal = (redacao) => {
    const total =
      (Number(redacao.competencia1) || 0) +
      (Number(redacao.competencia2) || 0) +
      (Number(redacao.competencia3) || 0) +
      (Number(redacao.competencia4) || 0) +
      (Number(redacao.competencia5) || 0);

    if (redacao.falta) {
      return 0;
    }

    return Math.round(total);
  };

  function enviarRedacao(e) {
    history.push(`/redacao/${e.target.id}`);
  }

  // Buscar tipo da turma
  const getTipoTurma = async () => {
    try {
      if (!id_turma) return null;
      
      const response = await api.get(`/getClasse/${id_turma}`);
      const tipo = response.data[0]?.type;
      setTipoTurma(tipo);
      return tipo;
    } catch (error) {
      console.error("Erro ao buscar tipo da turma:", error);
      return null;
    }
  };

  const loadRedacoes = async () => {
    const data = {
      id: user.id,
    };

    try {
      const response = await api.post(`/getRedacoes`, data);
      setRedacoes(response.data.redacoes);
    } catch (error) {
      toast.error("Erro ao carregar suas redações");
    }
  };

  // Função para carregar redações UERJ
  const loadRedacoesUERJ = async () => {
    try {
      if (!user || !user.id || !id_turma) {
        setRedacoesUERJ([]);
        return;
      }

      const response = await api.get(`/minhas-redacoes/uerj/${id_turma}`);
      
      if (response.data && Array.isArray(response.data.redacoes)) {
        // Transformar as redações UERJ para o formato compatível com a tabela
        const redacoesFormatadas = response.data.redacoes.map(redacao => ({
          id: redacao.id_redacao,
          nome: redacao.tema_nome,
          entrega: redacao.dia_limite, // Data limite
          hora: redacao.hora_limite ? redacao.hora_limite.substring(0, 5) : null, // Remover segundos
          competencia1: redacao.adequacao_tema || 0,
          competencia2: redacao.tipo_texto || 0,
          competencia3: redacao.argumentacao || 0,
          competencia4: redacao.periodo_coesao || 0,
          competencia5: redacao.modalidade || 0,
          corrigida: redacao.status === "CORRIGIDA",
          finalizada: redacao.status === "ENVIADA" || redacao.status === "CORRIGIDA" ? 1 : 0,
          falta: false,
          tipo: "UERJ", // Identificador para diferenciar
          status_uerj: redacao.status, // Status específico UERJ
          enviada_date: redacao.enviada_date,
          corrigida_date: redacao.corrigida_date
        }));
        
        setRedacoesUERJ(redacoesFormatadas);
      } else {
        setRedacoesUERJ([]);
      }
    } catch (error) {
      console.error('Erro ao carregar redações UERJ:', error);
      setRedacoesUERJ([]);
    }
  };

  const loadRedacoesIA = async () => {
    try {
      // Verificar se o usuário está logado e se há uma turma específica
      if (!user || !user.id || !id_turma) {
        setRedacoesIA([]);
        return;
      }

      const data = { classe_id: parseInt(id_turma) };
      const response = await api.post(`/getAllCorrecoes/ia`, data);
      
      if (response.data && Array.isArray(response.data)) {
        // Transformar as correções da IA para o formato compatível
        const correcoesDaTurma = response.data.map(correcao => ({
          id: correcao.id,
          nome: correcao.tema_por_extenso || "Redação IA",
          entrega: null, // Correções IA não têm data limite
          hora: null,
          competencia1: correcao.c1_nota,
          competencia2: correcao.c2_nota,
          competencia3: correcao.c3_nota,
          competencia4: correcao.c4_nota,
          competencia5: correcao.c5_nota,
          corrigida: true, // Sempre corrigida (é uma correção IA)
          finalizada: 1,
          falta: false,
          tipo: "IA", // Identificador para diferenciar
          classe_id: correcao.classe_id,
          created_at: correcao.created_at
        }));
        
        setRedacoesIA(correcoesDaTurma);
      } else {
        setRedacoesIA([]);
      }
    } catch (error) {
      console.error('Erro ao carregar correções da IA:', error);
      setRedacoesIA([]);
    }
  };

  const loadAllData = async () => {
    setLoading(true);
    try {
      // Primeiro buscar o tipo da turma
      const tipo = await getTipoTurma();
      
      // Carregar dados baseado no tipo da turma
      if (tipo === "UERJ") {
        // Para turmas UERJ, usar apenas o endpoint específico
        await loadRedacoesUERJ();
      } else {
        // Para turmas normais, carregar redações normais e IA
        await Promise.allSettled([
          loadRedacoes(),
          loadRedacoesIA()
        ]);
      }
    } catch (error) {
      console.error('Erro ao carregar dados:', error);
    } finally {
      setLoading(false);
    }
  };

  /* Validar datas se esta ou não expirado */
  const validaDataClasse = (dataTema, horaTema) => {
    let strData = dataTema;
    let srtHora = horaTema;

    var arr = `${strData} ${srtHora}`.split(/[- :]/);
    const validarData = new Date(
      arr[0],
      arr[1] - 1,
      arr[2],
      arr[3],
      arr[4],
      arr[5]
    );

    if (validarData > date1) {
      return false;
    } else {
      return true;
    }
  };

  useEffect(() => {
    loadAllData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Row>
        <Col>
          <div className="shadow-sm p-3 mb-4 bg-white rounded fdark">
            <strong>Minhas Redações: {turma}</strong>
          </div>
        </Col>
      </Row>
      <Row>
        {loading ? (
          <>
            <Col className="text-center">
              <div className="shadow p-3 mb-4 bg-white rounded fdark flex-c">
                <div>
                  <div className="spinner-grow text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                  <div className="spinner-grow text-secondary" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                  <div className="spinner-grow text-success" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                  <div className="spinner-grow text-danger" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                  <div className="spinner-grow text-warning" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                  <div className="spinner-grow text-info" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
                <div>
                  <strong>CARREGANDO</strong>
                </div>
              </div>
            </Col>
          </>
        ) : (
          <>
            <Col>
              <div className="shadow p-3 mb-4 bg-white rounded fdark">
                <div className="table-responsive">
                  {/* Combinar redações baseado no tipo da turma */}
                  {(() => {
                    let todasRedacoes = [];
                    
                    if (tipoTurma === "UERJ") {
                      // Para turmas UERJ, mostrar apenas redações UERJ
                      todasRedacoes = [...redacoesUERJ];
                    } else {
                      // Para turmas normais, combinar redações normais e de IA
                      todasRedacoes = [...redacoes, ...redacoesIA];
                    }
                    
                    return todasRedacoes.length > 0 ? (
                    <table className="table table-bordered table-striped">
                      <thead>
                        <tr>
                          <th className="th-grande">Data Limite Entrega</th>
                          <th className="th-xl">Tema</th>
                          <th className="th-pequeno">Tipo</th>
                          {tipoTurma === "UERJ" ? (
                            <>
                              <th className="th-grande">Adequação Tema</th>
                              <th className="th-grande">Tipo Texto</th>
                              <th className="th-grande">Argumentação</th>
                              <th className="th-grande">Período Coesão</th>
                              <th className="th-grande">Modalidade</th>
                            </>
                          ) : (
                            <>
                              <th className="th-grande">Competência 1</th>
                              <th className="th-grande">Competência 2</th>
                              <th className="th-grande">Competência 3</th>
                              <th className="th-grande">Competência 4</th>
                              <th className="th-grande">Competência 5</th>
                            </>
                          )}
                          <th className="th-grande">Total</th>
                          <th className="th-grande">Status</th>
                          <th className="th-grande">Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        {todasRedacoes.map((redacao) => (
                          <tr key={`${redacao.tipo || 'normal'}-${redacao.id}`}>
                            <td>
                              {redacao.entrega ? (
                                <>
                                  {redacao.entrega &&
                                    redacao.entrega
                                      .split("-")
                                      .reverse()
                                      .join("/")}
                                  <br />
                                  às {redacao.hora && redacao.hora}
                                </>
                              ) : (
                                <>---</>
                              )}
                            </td>
                            <td>
                              {redacao.nome}
                            </td>
                            <td>
                              {redacao.tipo === "IA" ? (
                                <span className="badge badge-pill badge-info">IA</span>
                              ) : redacao.tipo === "UERJ" ? (
                                <span className="badge badge-pill badge-warning">UERJ</span>
                              ) : (
                                <span className="badge badge-pill badge-secondary">Normal</span>
                              )}
                            </td>
                            <td>{redacao.competencia1}</td>
                            <td>{redacao.competencia2}</td>
                            <td>{redacao.competencia3}</td>
                            <td>{redacao.competencia4}</td>
                            <td>{redacao.competencia5}</td>
                            <td>{trazerTotal(redacao)}</td>
                            <td>
                              {redacao.corrigida ? (
                                <>
                                  <span className="badge badge-pill badge-success">
                                    Corrigida
                                  </span>
                                </>
                              ) : (
                                <>
                                  {redacao.finalizada === 1 ? (
                                    <span className="badge badge-pill badge-info">
                                      Aguardando Correção
                                    </span>
                                  ) : (
                                    <span className="badge badge-pill badge-danger">
                                      {redacao.tipo === "UERJ" ? "Escolhida - Envio pendente" : "Envio pendente"}
                                    </span>
                                  )}
                                </>
                              )}
                            </td>
                            <td>
                              {redacao.tipo === "IA" ? (
                                <Link
                                  to={`/correcao-ia/${redacao.id}`}
                                  className="btn btn-success"
                                >
                                  Ver Correção IA
                                </Link>
                              ) : redacao.tipo === "UERJ" ? (
                                <>
                                  {redacao.corrigida ? (
                                    <Link
                                      to={`/visualizar-correcao-uerj/${redacao.id}`}
                                      className="btn btn-success"
                                    >
                                      Ver Correção
                                    </Link>
                                  ) : (
                                    <>
                                      {redacao.finalizada === 1 ? (
                                        <button className="btn btn-info">
                                          Aguardar Correção
                                        </button>
                                      ) : (
                                        <>
                                          {redacao.entrega && redacao.hora && validaDataClasse(
                                            redacao.entrega,
                                            `${redacao.hora}:00`
                                          ) ? (
                                            <>
                                              <span className="btn btn-danger">
                                                Expirado 
                                              </span>
                                            </>
                                          ) : (
                                            <>
                                              <Link
                                                to={`/upload-redacao-uerj/${redacao.id}`}
                                                className="btn btn-primary"
                                              >
                                                Enviar Redação
                                              </Link>
                                            </>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                </>
                              ) : (
                                <>
                                  {redacao.corrigida ? (
                                    <Link
                                      to={`/correcao/${redacao.id}`}
                                      className="btn btn-success"
                                    >
                                      Ver Correção
                                    </Link>
                                  ) : (
                                    <>
                                      {redacao.finalizada === 1 ? (
                                        <button className="btn btn-info">
                                          Aguardar Correção
                                        </button>
                                      ) : (
                                        <>
                                          {validaDataClasse(
                                            redacao.entrega,
                                            `${redacao.hora}:00`
                                          ) ? (
                                            <>
                                              <span className="btn btn-danger">
                                                Expirado 
                                              </span>
                                            </>
                                          ) : (
                                            <>
                                              <button
                                                className="btn btn-info"
                                                id={redacao.id}
                                                onClick={enviarRedacao}
                                              >
                                                Enviar Correção
                                              </button>
                                            </>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                </>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <span className="badge badge-pill badge-danger">
                      {tipoTurma === "UERJ" 
                        ? "Você não possui redações UERJ, escolha um tema em atividades"
                        : "Você não possui redações, escolha um tema em atividades"
                      }
                    </span>
                  );
                  })()}
                </div>
              </div>
            </Col>
          </>
        )}
      </Row>
    </>
  );
};

export default ListaRedacoes;
